module.exports = __webpack_public_path__ + "static/33-10ab963911431e467c6df665586895f1.jpg";